export default "__VITE_ASSET__BgHlEad5__"